import * as React from "react";
import { forwardRef } from "react";
const SvgViewAttributeTableInverseSelection = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 17, viewBox: "0 0 24 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6.24285 0.51416L1.73581 5.30289H21.7358", stroke: "#5C5C5C", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M17.2288 15.7256L21.7358 10.9369H1.73581", stroke: "#5C5C5C", strokeWidth: 1.5 }));
const ForwardRef = forwardRef(SvgViewAttributeTableInverseSelection);
export default ForwardRef;
